import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid bg-blue" }
const _hoisted_2 = { class: "row vh-100 d-flex align-items-center justify-content-center" }
const _hoisted_3 = { class: "col-lg-4 col-md-4 col-sm-9 col-10 mx-auto" }
const _hoisted_4 = { class: "card shadow" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", { class: "mb-3 text-center" }, " Login ", -1)
const _hoisted_7 = { class: "mb-3" }
const _hoisted_8 = { class: "mb-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "btn btn-primary btn-sm" }, " Submit ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("form", {
              onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_7, [
                _withDirectives(_createElementVNode("input", {
                  type: "email",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loginData.email) = $event)),
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.loginData.email]
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _withDirectives(_createElementVNode("input", {
                  type: "password",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.loginData.password) = $event)),
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.loginData.password]
                ])
              ]),
              _hoisted_9
            ], 32)
          ])
        ])
      ])
    ])
  ]))
}